import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import ErrorPage from "shared/ErrorPage";

export default function ErrorPageProvider({ children }) {
  return <ErrorBoundary FallbackComponent={ErrorPage}>{children}</ErrorBoundary>;
}
